import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import EditActTransComp from "./Component/EditActTransComp"


const EditActTrans =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EditActTransComp />
        </div>
        <Footer />
        </>
    )
}

export default EditActTrans